class Api {
  constructor (url, headers) {
    this._url = url
    this._headers = headers
  }

  checkResponse (res) {
    return new Promise((resolve, reject) => {
      if (res.status === 204) {
        return resolve(res)
      }
      const func = res.status < 400 ? resolve : reject
      res.json().then(data => func(data))
    })
  }

  checkFileDownloadResponse (res) {
    return new Promise((resolve, reject) => {
      if (res.status < 400) {
        return res.blob().then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = "shopping-list";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();    
          a.remove();  //afterwards we remove the element again 
        })
      }
      reject()
    })
  }

  signin ({ email, password }) {
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/auth/token/login/`,
      {
        method: 'POST',
      
        headers: this._headers,
        body: JSON.stringify({
          email, password
        })
      }
    ).then(this.checkResponse)
  }

  signout () {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/auth/token/logout/`,
      {
        method: 'POST',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  signup ({ email, password, username, first_name, last_name, phone_user }) {
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/`,
      {
        method: 'POST',
        
        headers: this._headers,
        body: JSON.stringify({
          email, password, username, first_name, last_name, phone_user
        })
      }
    ).then(this.checkResponse)
  }

  getUserData () {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/me/`,
      {
        method: 'GET',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  changePassword ({ current_password, new_password }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/set_password/`,
      {
        method: 'POST',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        },
        body: JSON.stringify({ current_password, new_password })
      }
    ).then(this.checkResponse)
  }


  // recipes

  getRecipes ({
    page = 1,
    limit = 6,
    is_favorited = 0,
    is_in_shopping_cart = 0,
    author,
    tags,
    tower,
    is_in_top

  } = {}) {
      const token = localStorage.getItem('token')
      const authorization = token ? { 'authorization': `Token ${token}` } : {}
      const tagsString = tags ? tags.filter(tag => tag.value).map(tag => `&tags=${tag.slug}`).join('') : ''
      return fetch(
        `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/?page=${page}&limit=${limit}${author ? `&author=${author}` : ''}${is_favorited ? `&is_favorited=${is_favorited}` : ''}${is_in_shopping_cart ? `&is_in_shopping_cart=${is_in_shopping_cart}` : ''}${tagsString}${tower ? `&tower=${tower}` : ''}${is_in_top ? `&is_in_top=${is_in_top}` : ''}`,
        {
          method: 'GET',
         
          headers: {
            ...this._headers,
            ...authorization
          }
        }
      ).then(this.checkResponse)
  }

  getRecipe ({
    recipe_id
  }) {
    const token = localStorage.getItem('token')
    const authorization = token ? { 'authorization': `Token ${token}` } : {}
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${recipe_id}/`,
      {
        method: 'GET',
       
        headers: {
          ...this._headers,
          ...authorization
        }
      }
    ).then(this.checkResponse)
  }

  createRecipe ({
    name = '',
    image,
    tags = [],
    cooking_time = 0,
    text = '',
    tower = '',
    images_recipe = []
    
  }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/`,
      {
        method: 'POST',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        },
        body: JSON.stringify({
          name,
          image,
          tags,
          cooking_time,
          text,
          tower,
          images_recipe
        })
      }
    ).then(this.checkResponse)
  }

  updateRecipe ({
    name,
    recipe_id,
    image,
    tags,
    cooking_time,
    text,
    tower,
    images_recipe
    
  }, wasImageUpdated) { // image was changed
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${recipe_id}/`,
      {
        method: 'PATCH',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        },
        body: JSON.stringify({
          name,
          id: recipe_id,
          image: wasImageUpdated ? image : undefined,
          tags,
          cooking_time: Number(cooking_time),
          text,
          tower,
          images_recipe
        })
      }
    ).then(this.checkResponse)
  }

  addToFavorites ({ id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${id}/favorite/`,
      {
        method: 'GET',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  removeFromFavorites ({ id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${id}/favorite/`,
      {
        method: 'DELETE',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  getUser ({ id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/${id}/`,
      {
        method: 'GET',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  getUsers ({
    page = 1,
    limit = 6
  }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/?page=${page}&limit=${limit}`,
      {
        method: 'GET',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  // subscriptions

  getSubscriptions ({
    page, 
    limit = 6,
    recipes_limit = 3
  }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/subscriptions/?page=${page}&limit=${limit}&recipes_limit=${recipes_limit}`,
      {
        method: 'GET',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  deleteSubscriptions ({
    author_id
  }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/${author_id}/subscribe/`,
      {
        method: 'DELETE',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  subscribe ({
    author_id
  }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/users/${author_id}/subscribe/`,
      {
        method: 'GET',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  // ingredients
  // getIngredients ({ name }) {
  //   const token = localStorage.getItem('token')
  //   return fetch(
  //     `/api/ingredients/?name=${name}`,
  //     {
  //       method: 'GET',
  //       headers: {
  //         ...this._headers
  //       }
  //     }
  //   ).then(this.checkResponse)
  // }

  // tags
  getTags () {
    // const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/tags/`,
      {
        method: 'GET',
        
        headers: {
          ...this._headers
        }
      }
    ).then(this.checkResponse)
  }


  addToOrders ({ id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${id}/shopping_cart/`,
      {
        method: 'GET',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  removeFromOrders ({ id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${id}/shopping_cart/`,
      {
        method: 'DELETE',
        
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  deleteRecipe ({ recipe_id }) {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/${recipe_id}/`,
      {
        method: 'DELETE',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkResponse)
  }

  downloadFile () {
    const token = localStorage.getItem('token')
    return fetch(
      `${process.env.REACT_APP_API_URL_SERVER}/api/recipes/download_shopping_cart/`,
      {
        method: 'GET',
       
        headers: {
          ...this._headers,
          'authorization': `Token ${token}`
        }
      }
    ).then(this.checkFileDownloadResponse)
  }
}
export default new Api(process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : process.env.REACT_APP_API_URL_SERVER, { 'Content-Type': 'application/json' })
